import PolicyLayout from "./PolicyLayout";

export default function TermsPage() {
  return (
    <PolicyLayout
      title="Terms of Service"
      updated="December 2025"
      testId="terms-page"
    >
      <p>
        Welcome to Me Amor. By accessing or using our website (meamorgifts.com)
        or purchasing any of our gift boxes or services, you agree to be bound
        by these Terms of Service. Please read them carefully.
      </p>

      <h2>1. About us</h2>
      <p>
        Me Amor is a small business based in New Zealand offering seasonal
        subscription boxes and one-off gift kits for girls aged approximately
        4–15. All references to &ldquo;we&rdquo;, &ldquo;our&rdquo; or
        &ldquo;us&rdquo; refer to Me Amor. Contact:{" "}
        <a href="mailto:empower.meamor@gmail.com">empower.meamor@gmail.com</a>.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        To purchase from Me Amor you must be at least 18 years of age or have
        the consent of a parent or legal guardian. Our products are designed
        as gifts for children, but purchases are made by adults.
      </p>

      <h2>3. Products & subscriptions</h2>
      <ul>
        <li>
          <strong>One-off boxes</strong> (e.g. Activity Kit, Birthday Kit) are
          single-purchase items.
        </li>
        <li>
          <strong>Seasonal Subscription Box</strong> is a recurring
          subscription that delivers a new box every three (3) months at a
          discounted rate compared to one-off pricing.
        </li>
        <li>
          Box contents may vary based on availability. We reserve the right
          to substitute items of equal or greater value.
        </li>
      </ul>

      <h2>4. Pricing & payment</h2>
      <p>
        All prices are in New Zealand Dollars (NZD) and are inclusive of GST
        where applicable. Prices may change from time to time; the price
        displayed at checkout is the price you will pay.
      </p>
      <p>
        Payments are processed securely by <strong>Stripe</strong>. Me Amor
        does not receive or store your full card details. See our{" "}
        <a href="/privacy">Privacy Policy</a> for more.
      </p>

      <h2>5. Orders & acceptance</h2>
      <p>
        Placing an order constitutes an offer to purchase. Your order is
        confirmed once we send you a confirmation email and payment has been
        successfully processed. We reserve the right to refuse or cancel any
        order at our discretion.
      </p>

      <h2>6. Personalisation</h2>
      <p>
        Where personalisation is offered (currently on the Birthday Kit),
        please double-check your details at checkout. Personalised items
        cannot be exchanged or refunded except where required by the
        Consumer Guarantees Act 1993.
      </p>

      <h2>7. Shipping</h2>
      <p>
        Shipping details and expected timelines are covered in our{" "}
        <a href="/shipping">Shipping &amp; Delivery Policy</a>.
      </p>

      <h2>8. Refunds, returns & subscription cancellations</h2>
      <p>
        See our <a href="/refunds">Refund, Return &amp; Cancellation Policy</a>{" "}
        for full details.
      </p>

      <h2>9. Intellectual property</h2>
      <p>
        All content on this website — including the Me Amor name, logo,
        photography, product designs and text — is our intellectual property
        or used with permission, and may not be reproduced without our written
        consent.
      </p>

      <h2>10. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, Me Amor is not liable for any
        indirect, incidental or consequential loss arising from the use of
        our website or products. Nothing in these Terms limits your rights
        under the Consumer Guarantees Act 1993 or the Fair Trading Act 1986.
      </p>

      <h2>11. Governing law</h2>
      <p>
        These Terms are governed by the laws of New Zealand. Any dispute will
        be resolved in the New Zealand courts.
      </p>

      <h2>12. Changes</h2>
      <p>
        We may update these Terms from time to time. The current version will
        always be available at meamorgifts.com/terms.
      </p>
    </PolicyLayout>
  );
}
